import axios from "axios";
import { Toast } from "vant";
// 获取环境变量中的API基础URL，如果未定义则使用默认值
const API_BASE_URL =
  process.env.VUE_APP_API_BASE_URL || "http://101.35.126.37:8081/api/app";

const IMAGE_BASE_URL =
  process.env.VUE_APP_IMAGE_BASE_URL || "http://101.35.126.37:8081/api/app";

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://112.6.228.172:18081/api/app', // 设置固定基础URL
  baseURL: API_BASE_URL, // 测试环境
  timeout: 10000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // 添加版本号和token
    config.headers["App-Version-Code"] = "v2.0.0";
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;

    // 根据业务状态码处理
    if (res.code !== 200) {
      Toast.fail(res.message || "Error");
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    // 对响应错误做些什么
    Toast.fail(error.message || "请求失败");
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param {string} url 请求地址
 * @param {object} params 请求参数
 * @returns {Promise}
 */
export function get(url, params = {}) {
  return service({
    method: "get",
    url,
    params,
  });
}

/**
 * 封装post方法
 * @param {string} url 请求地址
 * @param {object} data 请求体数据
 * @returns {Promise}
 */
export function post(url, data = {}) {
  return service({
    method: "post",
    url,
    data,
  });
}
/**
 * 封装postJSON方法
 * @param {string} url 请求地址
 * @param {object} data 请求体数据
 * @returns {Promise}
 */
export function postJSON(url, data = "") {
  return service({
    method: "post",
    url,
    data,
  });
}

/**
 * 封装put方法
 * @param {string} url 请求地址
 * @param {object} data 请求体数据
 * @returns {Promise}
 */
export function put(url, data = {}) {
  return service({
    method: "put",
    url,
    data,
  });
}

/**
 * 封装delete方法
 * @param {string} url 请求地址
 * @param {object} params 请求参数
 * @returns {Promise}
 */
export function del(url, params = {}) {
  return service({
    method: "delete",
    url,
    params,
  });
}

export default service;

Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};
